import { InjectionToken } from '@angular/core';
import { SourceApp } from '../enums/source-app.enum';

export const SOURCE_APP = new InjectionToken<SourceApp>('SOURCE_APP');
